import { InjectionToken } from '@angular/core';
import { EmbeddedModalService } from '../interfaces/embedded-modal-service';

export const EMBEDDED_MODAL_SERVICE = new InjectionToken<EmbeddedModalService>('EMBEDDED_MODAL_SERVICE');
